export interface Unit {
  id?: string
  key: string | null
  x: number
  y: number
}

const units: Unit[] = [
  {
    id: 'billboard',
    // key: '7dc6edc62ab1060d168ed46b00497cda', // Passback
    key: '70e08ec7d3c12e1005dd04d8d3111c37', // Sovrn
    x: 970,
    y: 250,
  },
  {
    id: 'half-page',
    // key: 'ec7459f853bfc67308749d802edc8de9', // Passback
    key: '51c782f046197d866bab29762ac8f31f', // Sovrn
    x: 300,
    y: 600,
  },
  {
    id: 'leaderboard',
    // key: '620de76321a9bb2dabbe54d67b30aedd', // Passback
    key: '931700cd3d4dc924197db2454317d3fc', // Sovrn
    x: 728,
    y: 90,
  },
  {
    id: 'mpu',
    // key: '29c77f4f5dd89bf95eedcb71ec7f97d7', // Passback
    key: '6c40689fe8c6ff6f7742c920a6087289', // Sovrn
    x: 300,
    y: 250,
  },
  {
    id: 'wide-skyscraper',
    // key: '23d8d13d1a7806148587e773753cf23f', // Passback
    key: 'd3f55c92aef35c76c538e1bf2612c661', // Sovrn
    x: 160,
    y: 600,
  },
  {
    id: 'skyscraper',
    key: '489410f2620318dcbda0903d22974e8b', // House unit
    x: 120,
    y: 600,
  },
  {
    id: 'rectangle',
    key: '42b50cc1d2f1cebc0e03bf19d4dafcfb', // House unit
    x: 180,
    y: 150,
  },
  {
    id: 'square',
    key: 'e15a85da394ac46df0778816d3c42921', // House unit
    x: 250,
    y: 250,
  },
  {
    id: 'micro-bar',
    key: '23beda3e9e902ca2b62ec1e92ff226db', // House unit
    x: 88,
    y: 31,
  },
];

export default units;
